module.exports = __webpack_public_path__ + "img/pr-3.df5a5489.png";